export function collectFormData() {
    const dispatchEventToGTM = function dispatchEventToGTM(event) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            debug: false
        };
        var _TIMEOUT = 500;
        var attempt = 1;
        var interval = setInterval(function () {
            if (window.dataLayer) {
                options.debug && console.log('==> Event pushed to dataLayer with :: ', 'success', event);
                window.dataLayer.push(event);
                window.clearInterval(interval);
            } else {
                options.debug && console.log('==> dataLayer not available, retrying... attempt No :: ', 'process', attempt);
                attempt += 1;
            }
        }, _TIMEOUT);
    };

    $('#wpsl-search-btn').on('click', function () {
        const inputValue = $('#wpsl-search-input').val();

        if (inputValue) {
            dispatchEventToGTM({
                'event': 'city',
                'Where to Buy': inputValue
            }, {
                debug: true
            });
        }
    });
}
